module.exports = __webpack_public_path__ + "static/img/pbrand.8bc40f2a.png";